<ng-template #template let-sort="sortFn">
  <div
    class="datatable-header-cell-wrapper project-name-header-cell"
    [ngClass]="{ 'project-name-header-cell--favourited': favourite }"
  >
    <!-- <svg-icon
      [src]="'/assets/img/ic-star-filled.svg'"
      [svgStyle]="{ width: '18px', height: '18px' }"
      (click)="filterFavourite()"
    /> -->
    <span class="datatable-header-cell-label" (click)="sort()">
      {{ 'ProjectsList.Columns.name' | translate }}
    </span>
  </div>
</ng-template>
